import {
  TabCount,
  TabItem,
  TabsWrapper,
} from 'modules/Drive/Partials/DriveTabs/Style/style'
import React from 'react'
const DriveTabs = ({
  selected,
  selectedType,
  count = 0,
  pastDriveCount,
  upcominngDriveCount,
  onGoingDriveCount,
}) => {
  const selectiontype = selected

  return (
    <TabsWrapper>
      <TabItem
        isActive={selectiontype == 'UPCOMING'}
        onClick={() => {
          selectedType('UPCOMING')
        }}
      >
        Upcoming Drives <TabCount>{upcominngDriveCount}</TabCount>
      </TabItem>
      <TabItem
        isActive={selectiontype == 'ONGOING'}
        onClick={() => {
          selectedType('ONGOING')
        }}
      >
        Ongoing Drives <TabCount>{onGoingDriveCount}</TabCount>
      </TabItem>
      <TabItem
        isActive={selectiontype == 'PAST'}
        onClick={() => {
          selectedType('PAST')
        }}
      >
        Past Drives <TabCount>{pastDriveCount}</TabCount>
      </TabItem>
    </TabsWrapper>
  )
}

export default DriveTabs
